// extracted by mini-css-extract-plugin
module.exports = {"chart_card":"ChartCard_chart_card__1wgyP","chart_card_title":"ChartCard_chart_card_title__r6u5w","chart_card_content":"ChartCard_chart_card_content__2CFfV"};